import { render, staticRenderFns } from "./projectReviewIndex.vue?vue&type=template&id=10e3e7b9&"
import script from "./projectReviewIndex.vue?vue&type=script&lang=js&"
export * from "./projectReviewIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports